<template>
  <div class="body"
    style="background: radial-gradient(circle, rgba(45,46,47,1) 20%, rgba(111,142,148,1) 100%);padding:12% 35% 20% 35%;height: 100vh!important;">
    <div class="vue-template">
      <form>
        <h3></h3>
        <div class="form-group">
          <label>{{ $t("Кодни киритинг") }}</label> {{min+':'}}<span v-if="sek<10">0</span>{{sek}}
          <input type="text" ref="focused" v-model="code" class="form-control form-control-lg" />
        </div>

        <button type="button" class="btn btn-dark btn-lg btn-block" @click="Send()">
          {{ $t("Сақлаш") }}
        </button>
        <div class="end">
        </div>
        <p class="forgot-password text-right mt-2 mb-4"></p>
      </form>
    </div>
  </div>
</template>
<style>
  .vue-template form {
    padding: 2% 8%;
    border-radius: 10px;
    background: white;
  }

  .vs__selected-options {
    max-width: 100% !important;
  }
</style>

<script>
  export default {
    data() {
      return {
        time: 180,
        min: 0,
        sek: 0,
        code: '',
      };
    },
    methods: {
      Focus() {
        this.$refs.focused.focus();
      },
      Timer() {
        let self = this;
        setInterval(() => {
          self.time = self.time - 1;
          if (self.time > 60) {
            self.min = parseInt(self.time / 60);
            self.sek = self.time - (self.min * 60);
          } else if (self.time > 0) {
            self.min = 0
            self.sek = self.time - 1;
          }
        }, 1000);
      },
      Send() {
        let self = this;
        axios({
          method: "post",
          url: "api/v1/registration/phone-confirm",
          data: { sms_code: self.code, Phone: self.$route.params.phone }
        },
        ).then(function (response) {
          if (response.data.error == false) {
            localStorage.setItem("token", response.data.data.token);
            localStorage.setItem("user_role", response.data.data.role);
            localStorage.setItem("user_id", response.data.data.id);
            localStorage.setItem("username", response.data.data.username);
            localStorage.setItem("sklad_id", response.data.data.sklad_id);
            localStorage.setItem("rules", JSON.stringify(response.data.data.rules));
            self.$store.state.user_role = localStorage.getItem('user_role');
            self.$router.push({ name: "Бош сахифа" });
          } else {
            self.$store.state.errors = response.data.message;
          }
        });
      }
    },
    created() {
      this.Timer();
    },
    mounted() {
      let self = this;
      self.Focus();
    }
  };
</script>